var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5 0C76.8333 0 99 22.1667 99 49.5C99 76.8333 76.8333 99 49.5 99C22.1667 99 0 76.8333 0 49.5C0 22.1667 22.1667 0 49.5 0ZM44.1969 53.7595V28.2825C44.1969 25.3618 46.5793 22.9794 49.5 22.9794C52.4207 22.9794 54.8031 25.3839 54.8031 28.2825V53.7595C54.8031 56.6581 52.4207 59.0626 49.5 59.0626C46.5793 59.0626 44.1969 56.6802 44.1969 53.7595ZM49.4771 64.7504C52.7961 64.7504 55.488 67.4423 55.488 70.7609C55.488 74.08 52.7961 76.7719 49.4771 76.7719C46.1584 76.7719 43.4665 74.08 43.4665 70.7609C43.4665 67.4423 46.1584 64.7504 49.4771 64.7504Z",
    fill: "#D30808"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/ErrorIcon.49834a2b60adae2885f734ca6827dff6.svg";
export { ForwardRef as ReactComponent };